import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppShell } from '../shared/components/AppShell';

export function AppLayout(): React.ReactElement {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
